import React from 'react';
import AButton from '../../../../common/form-fields-mui/AButton';

const ActionButtonFooter = ({ saveHandler, discardHandler }) => {
    return (
        <div>
            <AButton
                variant='primary_filled'
                className='no-ml-btn'
                onClick={saveHandler}
            >
                Apply Changes
            </AButton>

            <AButton
                variant='outline_danger'
                onClick={discardHandler}
            >
                Discard Changes
            </AButton>
        </div>


    );
}

export default ActionButtonFooter;